module.exports = __webpack_public_path__ + "img/sankaku_6_red.a80ef240.png";